import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "potential_red_light_camera_violation",
  localization: {
    en: {
      title: "Potential Red Light Violation",
      settingsHeader: "Potential Red Light Violation Detection",
    },
    fr: {
      title: "Violation potentielle de caméra de feu rouge",
      settingsHeader: "Détection de violation potentielle de caméra de feu rouge",
    }
  },
  proto: {
    name: "EVENT_RAVEN_POTENTIAL_RED_LIGHT_CAMERA_VIOLATION",
    value: 171
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
    prod: false
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_ROAD,
  showBetaDecoration: false,
}
